export const GET_CODES_FOR_IMPORT_REPORT_REQUEST = 'GET_CODES_FOR_IMPORT_REPORT_REQUEST' as const;
export const GET_CODES_FOR_IMPORT_REPORT_SUCCESS = 'GET_CODES_FOR_IMPORT_REPORT_SUCCESS' as const;
export const GET_CODES_FOR_IMPORT_REPORT_ERROR = 'GET_CODES_FOR_IMPORT_REPORT_ERROR' as const;

export const CLOSE_ERROR_POPUP_REPORT_ERROR = 'CLOSE_ERROR_POPUP_REPORT_ERROR' as const;
